// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageSlider.css */


.slideContainer1 {
  height: 900px;
  padding-left: 20%;
  padding-right: 20%;
  display: flex;
  justify-content: center;
}

.slideImg2 {
  height: 100%;
  object-Fit: cover;
  width: 100%;
}

.swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  border: 1px solid gray; /* 흰색 테두리 */
  background-color: transparent; /* 내부 투명 */
  border-radius: 50%;
  opacity: 1;
  transition: background-color 0.3s, opacity 0.3s;
  
}

.custom-pagination3 .swiper-pagination-bullet-active {
  background-color: gray; /* 선택된 bullet은 흰색 */
  border-color: black; /* 테두리 유지 */
  opacity: 1;
  top: "25%" !important;
}

.custom-pagination3 {
  padding-left: 20%;
  width: 350px !important;
}


.swiper-button-prev::after,
.swiper-button-next::after {
  color: white;               /* 화살표 색상 */
  font-size: 60px !important;   /* 우선순위 강제로 높임 */
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6); /* 텍스트 그림자 */
}



/* 화면 너비가 767px 이하일 때 텍스트 크기 줄이기 */
@media (max-width: 767px) {
  .slideContainer1 {
    height: 400px;
    padding-left: 10%;
    padding-right: 10%;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 20px !important;   /* 우선순위 강제로 높임 */
  }

  .custom-pagination3 .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    
  }

  .custom-pagination3 {
    padding-left: 10%;
  }
}

@media (min-width: 768px) and (max-width: 1749px)  {
  .custom-pagination3 {
    width: 800px !important;
  }
}

/* 화면 너비가 1200px 이상일 때 텍스트 크기 크게 설정 */
@media (min-width: 1750px) {
  .custom-pagination3 {
    width: 800px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageSlider2.css"],"names":[],"mappings":"AAAA,oBAAoB;;;AAGpB;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,WAAW;EACnC,6BAA6B,EAAE,UAAU;EACzC,kBAAkB;EAClB,UAAU;EACV,+CAA+C;;AAEjD;;AAEA;EACE,sBAAsB,EAAE,mBAAmB;EAC3C,mBAAmB,EAAE,WAAW;EAChC,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;;AAGA;;EAEE,YAAY,gBAAgB,WAAW;EACvC,0BAA0B,IAAI,gBAAgB;EAC9C,iBAAiB;EACjB,2CAA2C,EAAE,YAAY;AAC3D;;;;AAIA,kCAAkC;AAClC;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B,IAAI,gBAAgB;EAChD;;EAEA;IACE,UAAU;IACV,WAAW;;EAEb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ImageSlider.css */\n\n\n.slideContainer1 {\n  height: 900px;\n  padding-left: 20%;\n  padding-right: 20%;\n  display: flex;\n  justify-content: center;\n}\n\n.slideImg2 {\n  height: 100%;\n  object-Fit: cover;\n  width: 100%;\n}\n\n.swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  border: 1px solid gray; /* 흰색 테두리 */\n  background-color: transparent; /* 내부 투명 */\n  border-radius: 50%;\n  opacity: 1;\n  transition: background-color 0.3s, opacity 0.3s;\n  \n}\n\n.custom-pagination3 .swiper-pagination-bullet-active {\n  background-color: gray; /* 선택된 bullet은 흰색 */\n  border-color: black; /* 테두리 유지 */\n  opacity: 1;\n  top: \"25%\" !important;\n}\n\n.custom-pagination3 {\n  padding-left: 20%;\n  width: 350px !important;\n}\n\n\n.swiper-button-prev::after,\n.swiper-button-next::after {\n  color: white;               /* 화살표 색상 */\n  font-size: 60px !important;   /* 우선순위 강제로 높임 */\n  font-weight: bold;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6); /* 텍스트 그림자 */\n}\n\n\n\n/* 화면 너비가 767px 이하일 때 텍스트 크기 줄이기 */\n@media (max-width: 767px) {\n  .slideContainer1 {\n    height: 400px;\n    padding-left: 10%;\n    padding-right: 10%;\n  }\n\n  .swiper-button-prev::after,\n  .swiper-button-next::after {\n    font-size: 20px !important;   /* 우선순위 강제로 높임 */\n  }\n\n  .custom-pagination3 .swiper-pagination-bullet {\n    width: 8px;\n    height: 8px;\n    \n  }\n\n  .custom-pagination3 {\n    padding-left: 10%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1749px)  {\n  .custom-pagination3 {\n    width: 800px !important;\n  }\n}\n\n/* 화면 너비가 1200px 이상일 때 텍스트 크기 크게 설정 */\n@media (min-width: 1750px) {\n  .custom-pagination3 {\n    width: 800px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
